(function () {
  function openKlaviyoForm(e) {
    const link = e.target.closest('a[href="#signup6"]');
    if (!link) return;

    e.preventDefault();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SmLfAc']);
  }

  document.addEventListener('click', openKlaviyoForm);
})();


(function () {
  var targetPath = "/products/welding-machine-giveaway-bundle";

  if (window.location.pathname === targetPath) {
    sessionStorage.setItem("open_klaviyo_form_SmLfAc", "true");
    window.location.href = "/";
  }

  if (
    window.location.pathname === "/" &&
    sessionStorage.getItem("open_klaviyo_form_SmLfAc") === "true"
  ) {
    sessionStorage.removeItem("open_klaviyo_form_SmLfAc");

    var attempts = 0;
    var maxAttempts = 30;

    var openKlaviyoForm = setInterval(function () {
      attempts++;

      window._klOnsite = window._klOnsite || [];

      if (window._klOnsite) {
        window._klOnsite.push(["openForm", "SmLfAc"]);
        clearInterval(openKlaviyoForm);
      }

      if (attempts >= maxAttempts) {
        clearInterval(openKlaviyoForm);
      }
    }, 500);
  }
})();


(function () {
  console.log('Current pathname:', window.location.pathname);

  if (window.location.pathname !== '/cart') {
    console.log('Not on /cart page');
    return;
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('Cart items:', cart.items);

      const hasMiller = cart.items.some(item => {
        const match =
          (item.title && item.title.includes('Miller Pipe Pro Welding Machine')) ||
          (item.product_title && item.product_title.includes('Miller Pipe Pro Welding Machine'));

        console.log('Checking item:', item.title, 'Match:', match);
        return match;
      });

      console.log('Final hasMiller result:', hasMiller);

      // INVERTED CONDITION
      if (!hasMiller) {
        console.log('Miller product NOT found → hiding button container');
        document.querySelectorAll('.spp2__button-container.spp2__tooltip_top')
          .forEach(el => el.style.display = 'none');
      } else {
        console.log('Miller product found → leaving button visible');
      }

    })
    .catch(err => console.error('Cart fetch error:', err));
})();


if (window.location.pathname === '/products/painted-laser-uno-carbon-fiber-pancake-welding-hood-internal') {
  window.location.replace('https://shop.pipelinerscloud.com/products/painted-laser-uno-carbon-fiber-pancake-welding-hood');
}